module.exports = __webpack_public_path__ + "static/blog-img-19-05e166f821edd042d4b6491796548578.png";